<template>
  <footer class="footer mt-auto py-5 bg-white border-top">
    <div class="container">
      <div class="row gy-4 align-items-center">
        
        <div class="col-lg-4 text-center text-lg-start">
          <div class="footer-logo mb-2">
            <h4 class="fw-bold mb-0 text-gradient">AI Strategy Hub</h4>
          </div>
          <p class="text-muted small pe-lg-4">
            Empowering decision-makers with ultra-fast AI insights powered by Groq & Llama 3.1.
          </p>
          <div class="copyright text-muted x-small">
            © 2026 Crafted with <i class="fas fa-heart text-danger"></i> by <strong>Dirar</strong>
          </div>
        </div>

        <div class="col-lg-4 text-center">
          <h6 class="fw-bold mb-3 text-dark text-uppercase small tracking-wider">Quick Links</h6>
          <div class="d-flex justify-content-center gap-4">
            <router-link to="/privacy" class="footer-link">Privacy Policy</router-link>
            <router-link to="/license" class="footer-link">License</router-link>
            <a href="https://github.com/Diraribnsalah" target="_blank" class="footer-link github-icon">
              <i class="fab fa-github fa-lg"></i>
            </a>
          </div>
        </div>

        <div class="col-lg-4 text-center text-lg-end">
          <h6 class="fw-bold mb-3 text-dark text-uppercase small tracking-wider">Contact Developer</h6>
          <div class="contact-info d-flex flex-column align-items-lg-end gap-2">
            <a href="mailto:diraribnsalah@gmail.com" class="contact-item">
              <span class="small me-2">diraribnsalah@gmail.com</span>
              <div class="icon-circle bg-primary-light"><i class="fas fa-envelope text-primary"></i></div>
            </a>
            <a href="tel:0614517334" class="contact-item">
              <span class="small me-2">0614517334</span>
              <div class="icon-circle bg-success-light"><i class="fas fa-phone-alt text-success"></i></div>
            </a>
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<style scoped>
/* Import Google Font for a modern look */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');

.footer {
  font-family: 'Inter', sans-serif;
}

/* Gradient Text Effect */
.text-gradient {
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Links Styling */
.footer-link {
  text-decoration: none;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.footer-link:hover {
  color: #6366f1;
}

.github-icon:hover {
  transform: translateY(-3px);
  color: #333 !important;
}

/* Contact Items Styling */
.contact-item {
  text-decoration: none;
  color: #475569;
  display: flex;
  align-items: center;
  transition: opacity 0.3s ease;
}

.contact-item:hover {
  opacity: 0.8;
}

.icon-circle {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.85rem;
}

.bg-primary-light { background: rgba(99, 102, 241, 0.1); }
.bg-success-light { background: rgba(34, 197, 94, 0.1); }

.x-small { font-size: 0.75rem; }
.tracking-wider { letter-spacing: 0.05em; }

/* Responsive adjustments */
@media (max-width: 991px) {
  .contact-info { align-items: center !important; }
}
</style>